<template>
  <div>
    <q-form ref="editForm">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <c-card title="기본정보" class="cardClassDetailForm">
            <template slot="card-button">
              <q-btn-group outline >
                <c-btn
                  v-if="editable"
                  label="일지출력"
                  color="amber-7"
                  icon="print" />
              </q-btn-group>
            </template>
            <template slot="card-detail">
              <div class="col-6">
                <c-datepicker
                  label="작성일"
                  name="col1"
                  v-model="data.col1"
                />
              </div>
              <div class="col-6">
                <c-field
                  :editable="editable"
                  :data="data"
                  deptValue="col2"
                  type="dept_user"
                  label="작성부서 & 작성자"
                  name="col3"
                  v-model="data.col3">
                </c-field>
              </div>
              <div class="col-4">
                <c-plant required="true" type="edit" name="col0" v-model="data.col0" />
              </div>
              <div class="col-4">
                <c-select
                  :comboItems="whetherItems"
                  type="edit"
                  itemText="codeName"
                  itemValue="code"
                  name="col4"
                  label="날씨"
                  v-model="data.col4"
                ></c-select>
              </div>
              <div class="col-4">
                <c-text
                  :editable="editable"
                  label="온도"
                  suffix="℃"
                  name="col5"
                  v-model="data.col5">
                </c-text>
              </div>
            </template>
          </c-card>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <component :is="component1" :param.sync="popupParam" />
          <component :is="component2" :param.sync="popupParam" />
          <component :is="component3" :param.sync="popupParam" />
          <component :is="component4" :param.sync="popupParam" />
          <component :is="component5" :param.sync="popupParam" />
        </div>
      </div>
    </q-form>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>
<script>
// import selectConfig from '@/js/selectConfig';
// import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'daily-air-report-detail',
  props: {
    popupParam: {
      type: Object,
      default(){
        return {
          reportId: '',
          isFullScreen: true,
        }
      },
    },
    contentHeight: null,
  },
  data() {
    return {
      component1: null, // 콤포넌트
      component2: null, // 콤포넌트
      component3: null, // 콤포넌트
      component4: null, // 콤포넌트
      component5: null, // 콤포넌트
      whetherItems: [
        { code: '1', codeName: '맑음' },
        { code: '2', codeName: '흐림' },
        { code: '3', codeName: '눈' },
        { code: '4', codeName: '비' },
        { code: '5', codeName: '구름' },
      ],
      data: {
        col0: '',
        col1: '2021-01-05',
        col2: 'D10003',
        col3: 'U000000018',
        col4: '1',
        col5: '15',
        col6: '',
        col7: '',
      },
    };
  },

  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  computed: {
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      
      this.component1 = () => import(`${'./dailyAirReport01.vue'}`);
      this.component2 = () => import(`${'./dailyAirReport02.vue'}`);
      this.component3 = () => import(`${'./dailyAirReport03.vue'}`);
      this.component4 = () => import(`${'./dailyAirReport04.vue'}`);
      this.component5 = () => import(`${'./dailyAirReport05.vue'}`);

      this.getData();
    },
    getData() {
    },
  }
};
</script>